import { connect } from 'formik';
import { isEmpty } from 'lodash';
import styled from 'styled-components';

import { AdditionalInformation } from '@hivebrite/design-system/AdditionalInformation';
import { Box } from '@hivebrite/design-system/Box';

const ErrorsReminder = ({ formik }) => {
  if (formik.submitCount === 0 || formik.isValid || isEmpty(formik.errors)) {
    return null;
  }

  return (
    <div className="flex flex-center flex--justify-center">
      <Wrapper>
        <AdditionalInformation type="error" mt={0} id="errors_reminder">
          {__('Some errors have been found in the form')}
        </AdditionalInformation>
      </Wrapper>
    </div>
  );
};

export default connect(ErrorsReminder);

const Wrapper = styled(Box).attrs(() => ({
  display: 'block',
  borderRadius: '6px',
  p: '15px',
  width: { _: '100%', m: 'auto' },
}))``;
